// import auth from 'src/router/auth'
import Login from '../Login'
export default [
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]



// WEBPACK FOOTER //
// ./src/components/account/routes/index.js